"use client"

import { AboutUsTimelineProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const AboutUsTimeline = {
  label: "Tamda Media | About Us Timeline",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    items: {
      label: "Timeline Items",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Item ${index + 1}: ${item?.year || "No year"}`,
      arrayFields: {
        year: {
          label: "Year",
          type: "text",
        },
        image: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        date: {
          label: "Date",
          type: "text",
        },
        subtitle: {
          label: "Subtitle",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    title: "LỊCH SỬ",
    items: [
      {
        year: "2019",
        image: "",
        title: "TAMDA Ústí nad Labem",
        date: "22.06.2019",
        subtitle: "Khai trương Trung tâm thương mại TAMDA Ústí nad Labem",
        description: "Mô tả chi tiết về sự kiện...",
      },
    ],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
} as ComponentConfig<AboutUsTimelineProps>
